<template>
  <div class="nb-adulte-container">
    <div :style="{ backgroundImage: 'url(' + img + ')' }" class="img-responsive">
    </div>
    <div class="d-flex vertical-center display-element prtb-60px " :style="{ backgroundImage: 'url(' + img + ')' }">
      <div class="input-container">
        <input type="number" class="input-box" v-model="result"
          @input="$emit('update:modelValue', result); checkError()" />
        <div class="input-box-label" :style="{ 'text-align': textAlign }">{{ inputInfo.label }}</div>
        <div class="error">{{ error }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      result: null,
      error: null
    };
  },
  props: {
    img: String,
    inputInfo: Object,
    textAlign: { type: String, default: 'center' },
    modelValue: Object,
    bgAlign:{ type: String, default: 'center' },
  },
  methods: {
    checkError() {
      if (!this.result) {
        this.error = 'Vous devez entrer une valeur'
        this.$emit('onError', true)
      }
      else {
        this.error = null
        this.$emit('onError', false)
      }
    }
  },
  watch: {
    modelValue(newVal) {
      this.result = newVal;
    }
  }
};
</script>
<style scoped>
.input-box-container {
  position: relative;
  background-color: white;
  display: flex;
  justify-content: space-between;
  border-bottom-right-radius: 50px;
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
}

.input-box {
  border: 3px solid var(--Secondary-Noir, #3B3B3C);
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
  padding: 22px 35px;
  color: var(--text-color);
  font-family: var(--font);
  font-size: 42px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  box-sizing: border-box;
}

.input-container {
  display: flex;
  flex-direction: column;
  width:50%;
}

.input-box-label {
  color: var(--text-color);
  font-family: var(--font);
  font-size: 42px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.display-element {
  justify-content: end;
}

.nb-adulte-container {
  position: relative;
  background-color: white;
  display: flex;
  justify-content: space-between;
  border-bottom-right-radius: 50px;
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
  margin-top: 10px;
  flex-wrap: wrap;
}

.prtb-60px {
  padding-top: 60px;
  padding-bottom: 60px;
  padding-right: 60px;
  box-sizing: border-box;
  background-size: auto 100%;
  background-repeat: no-repeat;
  min-height: 350px;
  width: 100%;
}

.nb-adulte-input {
  width: 75px;
  height: 35px;
  padding: 10px 20px 10px 20px;
  box-shadow: 4px 4px 24px 0px rgba(0, 0, 0, 0.15);
  border: 3px solid var(--text-color);
  font-size: 35px;
  font-family: var(--font);
  text-align: center;
}

.label-nb {
  color: var(--text-color);
  text-align: left;
  font-family: var(--font);
  font-size: 25px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.description-nb {
  font-family: var(--font);
  color: var(--text-color);
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 28.2px;
  /* 141% */
}

.img-plus-minus {
  width: 60px;
}

.img-responsive {
  display: none;
}

@media screen and (max-width: 1300px) {
  .nb-adulte-img {
    min-height: 250px;
  }

  .nb-adulte-input {
    width: 50px;
    height: 20px;
    font-size: 25px;
  }
  .input-box-label {
    font-size:30px
  }
  .input-box {
    padding:10px 15px;
    font-size:30px;
  }
}
@media screen and (max-width: 900px) {
  .prtb-60px {
    padding-top: 20px;
    padding-bottom: 20px;
    padding-right: 20px;
    padding-left: 20px;
    min-height: 250px;
  }
  .input-box {
    padding:10px 15px;
    font-size:25px;
  }
}

@media screen and (max-width: 750px) {
  .prtb-60px {
    background-image: none !important;
  }

  .display-element {
    justify-content: center;
  }

  .img-responsive {
    display: block !important;
    box-sizing: border-box;
    background-size: contain;
    background-position: top center;
    background-repeat: no-repeat;
    min-height: 350px;
    width: 100%;
  }
  .input-box {
    padding:10px 15px;
    font-size:25px;
    width: 100%;
  }
  .input-container {
    display: flex;
    flex-direction: column;
    width:90%;
  }
  .labels>* {
    text-align: center;
  }

  .text-align-end {
    justify-content: center;
    text-align: center;
  }
}

@media screen and (max-width: 600px) {
  .nb-adulte-container {
    margin-top: 45px;
  }

  .nb-adulte-img {
    width: 100%;
  }

  .nb-adulte-img>img {
    width: 100%;
  }

  .label-nb {
    font-size: 18px;
  }

  .display-element {
    justify-content: center;
  }

  .p-60px {
    padding: 5px;
  }

  .prtb-60px {
    background-size: 100% auto;
    background-position: bottom;
  }
  .img-responsive {
    display: block !important;
    box-sizing: border-box;
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    min-height: 350px;
    width: 100%;
  }
}

@media screen and (max-width: 350px) {
}
</style>